import { useState } from 'react';
import { Box, Container, Fab, Popover, Stack, Typography, useTheme } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { ColorChangeHandler, CompactPicker } from 'react-color';
// TODO - use react-best-gradient-color-picker to add ability to do gradients and solid colors in 1 place
// - wait for react-best-gradient-color-picker to implement Typescript
// npm install react-best-gradient-color-picker
// import ColorPicker from 'react-best-gradient-color-picker'

interface Props {
    label: string;
    colorHex?: string;
    onColorChange: (colorHex: string) => void;
}

export const ColorPickerButton = (props: Props) => {
    const theme = useTheme();
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | HTMLDivElement | null>(null);
    const colorHexLocal = props.colorHex ?? theme.palette.background.default;
    // const [color, setColor] = useState('rgba(255,255,255,1)');

    const onColorChange: ColorChangeHandler = (color) => {
        props.onColorChange(color.hex);
    };

    const onEditClick = (event: React.MouseEvent<HTMLButtonElement | HTMLDivElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    return (
        <Container>
            <Stack direction="row" spacing={2} sx={{ alignItems: 'center', display: 'flex' }}>
                <Typography variant="subtitle1" gutterBottom>
                    {props.label}
                </Typography>
                <Box
                    sx={{
                        backgroundColor: colorHexLocal,
                        minWidth: 40,
                        minHeight: 40,
                        borderWidth: 2,
                        borderStyle: 'solid',
                        borderColor: 'white'
                    }}
                    onClick={onEditClick}
                />
                <Fab color="primary" aria-label="edit" onClick={onEditClick} size="medium">
                    <EditIcon />
                </Fab>
                <Popover
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right'
                    }}
                >
                    {/* <ColorPicker value={color} onChange={setColor} /> */}
                    <CompactPicker color={colorHexLocal} onChangeComplete={onColorChange} />
                </Popover>
            </Stack>
        </Container>
    );
};
